(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig( $stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
            .state('formula', {
                parent: 'app',
                url: '/formula?page&sort&search',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.formula.home.title',
                    title: 'Formula'
                },
                views: {
                    'formula@': {
                        templateUrl: 'app/entities/formula/formulas.html',
                        controller: 'FormulaController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function( $translate, $translatePartialLoader ) {
                        $translatePartialLoader.addPart('formula');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('formula-detail', {
                parent: 'app',
                url: '/formula/{id}',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.formula.detail.title',
                    title: 'Detail'
                },
                views: {
                    'formula-detail@': {
                        templateUrl: 'app/entities/formula/formula-detail.html',
                        controller: 'FormulaDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function( $translate, $translatePartialLoader ) {
                        $translatePartialLoader.addPart('formula');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'FormulaService', function($stateParams, FormulaService) {
                        return FormulaService.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'formula',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('formula-detail.edit', {
                parent: 'app',
                url: '/formula/detail/edit',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/formula/formula-dialog.html',
                        controller: 'FormulaDialogController',
                        controllerAs: 'vm',
                        background: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['FormulaService', function( FormulaService ) {
                                return FormulaService.get({id: $stateParams.id}).$promise;
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function( $translate, $translatePartialLoader ) {
                                $translatePartialLoader.addPart('formula');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                        }
                    }).result.then( function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('formula.new', {
                parent: 'app',
                url: '/formula/new',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/formula/formula-dialog.html',
                        controller: 'FormulaDialogController',
                        controllerAs: 'vm',
                        background: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function() {
                                return {
                                    createdOn: new Date(),
                                    createdBy: "user",
                                    modifiedOn: new Date(),
                                    modifiedBy: "user",
                                    label: null,
                                    type: null,
                                    rate: 0,
                                    parentString: null,
                                    resultString: null,
                                    parentGrowth: null,
                                    resultGrowth: null,
                                    active: true
                                }
                            },
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function( $translate, $translatePartialLoader ) {
                                $translatePartialLoader.addPart('formula');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                        }
                    }).result.then(function() {
                        $state.go('formula', null, { reload: true });
                    }, function() {
                        $state.go('formula');
                    });
                }]
            })
            .state('formula.edit', {
                parent: 'app',
                url: '/formula/{id}/edit',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/formula/formula-dialog.html',
                        controller: 'FormulaDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['FormulaService', function(FormulaService) {
                                return FormulaService.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('formula', null, { reload: true });
                    }, function() {
                        // $state.go('^');
                        $state.go('formula');
                    });
                }]
            })
            .state('formula.delete', {
                parent: 'app',
                url: '/formula/{id}/delete',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/formula/formula-delete-dialog.html',
                        controller: 'FormulaDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['FormulaService', function(FormulaService) {
                                return FormulaService.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('formula', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });

            $stickyStateProvider.enableDebug( true );
    }
})();
